import { Component, ReactNode } from 'react';

interface ErrorBoundaryProps {
    children: ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): ErrorBoundaryState {
        return { hasError: true };
    }

    // componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    //     /* Removed console statement */
    // }

    render(): ReactNode {
        if (this.state.hasError) {
            return (
                <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
                    <img
                        src="https://illustrations.popsy.co/amber/crashed-error.svg"
                        alt="Une erreur s'est produite"
                        className="w-64 h-64 mb-8"
                    />
                    <h1 className="text-2xl font-bold text-red-600 mb-2">Oups ! Quelque chose s'est mal passé</h1>
                    <p className="text-gray-700 mb-4">Nous sommes désolés pour ce désagrément. Veuillez essayer de rafraîchir la page.</p>
                    <button
                        onClick={() => window.location.reload()}
                        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
                    >
                        Rafraîchir la page
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;